module.exports = __webpack_public_path__ + "img/box2.e8418083.png";